import React, { useMemo, useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { authAPI } from '../services/authService';
import { clearAuthSession } from '../utils/passwordRecovery';
import './Login.css';

const AcceptInvitation = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = useMemo(() => params.get('token') || '', [params]);
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!token) {
      setError('Invitation link is missing or invalid.');
      return;
    }
    if (password !== confirm) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await authAPI.acceptInvitation({ token, newPassword: password });
      clearAuthSession();
      setSuccess('Password set successfully. You can now sign in.');
      setTimeout(() => navigate('/', { replace: true }), 1500);
    } catch (err) {
      setError(err?.response?.data?.message || 'Unable to accept invitation.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card" style={{ maxWidth: 480 }}>
        <div className="login-header">
          <h1 style={{ fontSize: 20, margin: 0 }}>Set Up Your Password</h1>
          <p className="subtitle">DEC Infra Client Correspondence Portal</p>
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        {success && <div className="alert alert-success">{success}</div>}
        <form className="login-form" onSubmit={onSubmit}>
          <div className="form-group">
            <label>New password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
          </div>
          <div className="form-group">
            <label>Confirm password</label>
            <input type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} />
          </div>
          <button className="btn-login" type="submit" disabled={loading || !!success}>
            {loading ? 'Saving…' : 'Activate Account'}
          </button>
        </form>
        <div className="login-footer-note">
          <Link className="login-link-btn" to="/">Back to login</Link>
        </div>
      </div>
    </div>
  );
};

export default AcceptInvitation;
